module.exports = __webpack_public_path__ + "static/media/hemi_head_bd_it-webfont.ec5a1af1.ttf";